/**
 * @generated SignedSource<<81a1e8e526954a14f6c94c8c234dae32>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment, RefetchableFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PollList_polls$data = {
  readonly edges: ReadonlyArray<{
    readonly node: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"PollItem_poll">;
    };
  }>;
  readonly id: string;
  readonly " $fragmentType": "PollList_polls";
};
export type PollList_polls$key = {
  readonly " $data"?: PollList_polls$data;
  readonly " $fragmentSpreads": FragmentRefs<"PollList_polls">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./PollListRefetchQuery.graphql'),
      "identifierField": "id"
    }
  },
  "name": "PollList_polls",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PollEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PollQuestion",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "PollItem_poll"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v0/*: any*/)
  ],
  "type": "PollConnection",
  "abstractKey": null
};
})();

(node as any).hash = "5c207e043ce88074f3e73b5bdda3e654";

export default node;
